import { withFullStoryExclude } from "../../../utils/fullStoryHelper";

const columns = [
    {
        Header: "glStatusOverviewGLSideLines_Nr",
        Accessor: "Nr",
        Filterable: false,
    },
    {
        Header: "glStatusOverviewGLSideLines_reconStatus",
        Accessor: "Status",
        Filterable: true,
    },
    {
        Header: "glStatusOverviewGLSideLines_companyCode",
        Accessor: "Company Code",
        Filterable: true,
    },
    {
        Header: "glStatusOverviewGLSideLines_documentNumber",
        Accessor: "Document Number",
        Filterable: true,
    },
    {
        Header: "glStatusOverviewGLSideLines_postingDate",
        Accessor: "Posting Date",
        Filterable: true,
        IsDate: true,
    },
    {
        Header: "glStatusOverviewGLSideLines_entryDate",
        Accessor: "Entry Date",
        Filterable: true,
        IsDate: true,
    },
    {
        Header: "glStatusOverviewGLSideLines_documentDate",
        Accessor: "Document Date",
        Filterable: true,
        IsDate: true,
    },
    {
        Header: "glStatusOverviewGLSideLines_currencyKey",
        Accessor: "Currency Key",
        Filterable: true,
    },
    {
        Header: "glStatusOverviewGLSideLines_documentCurrencyKey",
        Accessor: "Document Currency Key",
        Filterable: true,
    },
    {
        Header: "glStatusOverviewGLSideLines_generalLedgerAccount",
        Accessor: "GL Account",
        Filterable: true,
    },
    {
        Header: "glStatusOverviewGLSideLines_generalLedgerAccountText",
        Accessor: "GL Account Text",
        Filterable: true,
    },
    {
        Header: "glStatusOverviewGLSideLines_localTaxBaseAmount",
        Accessor: "Local Tax Base Amount",
        Filterable: true,
        IsCurrency: true,
        headerClassName: withFullStoryExclude(),
        className: withFullStoryExclude(),
    },
    {
        Header: "glStatusOverviewGLSideLines_localTaxAmount",
        Accessor: "Local Tax Amount",
        Filterable: true,
        IsCurrency: true,
        headerClassName: withFullStoryExclude(),
        className: withFullStoryExclude(),
    },
    {
        Header: "glStatusOverviewGLSideLines_documentTaxBaseAmount",
        Accessor: "Document Tax Base Amount",
        Filterable: true,
        IsCurrency: true,
        headerClassName: withFullStoryExclude(),
        className: withFullStoryExclude(),
    },
    {
        Header: "glStatusOverviewGLSideLines_documentTaxAmount",
        Accessor: "Document Tax Amount",
        Filterable: true,
        IsCurrency: true,
        headerClassName: withFullStoryExclude(),
        className: withFullStoryExclude(),
    },
];

export default columns;
